// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"141":"48515d35","307":"36cfa8d8","348":"319bf73a","790":"2234f7f0","833":"c6c9dba0"}[chunkId] + ".css";
};